module.exports = __webpack_public_path__ + "img/ry_banner_en.e52241cc.png";